
import { Component, Ref, InjectReactive, Mixins } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { Form } from "element-ui";
import UploadImg from "@/components/uploadImg.vue";
import { debounce, uniqWith } from "lodash";
import { IHomeInstance } from "@/types/global";
import { getStoreListByMerchant } from "@/api/store";
import { getMerchantDetail, saveOrUpdateMerchant } from "@/api/prescriptionDb";
import { detectionTypeList } from "@/api/appCompose";

@Component({
    components: {
        UploadImg
    }
})
export default class interfaceManage extends Mixins(loading) {
    @Ref("validateForm") readonly validateFormRef !: Form;
    @Ref("editBox") readonly editBoxRef !: HTMLElement;
    @InjectReactive() HomeInstance !: IHomeInstance;

    merchantId = this.$route.query.merchantId || "";
    brandName = this.$route.query.brandName || "";

    // NOTE: 锚点导航分组，id 与模板中 form-section 的 id（anchor-xxx）一一对应
    anchorList = [
        { id: "brain", label: "中医大脑" },
        { id: "mini", label: "智养小程序" },
        { id: "wsApp", label: "望舌知康APP" },
        { id: "wsMini", label: "望舌知康小程序" },
    ];
    activeAnchor = "brain";
    // NOTE: 锚点平滑滚动期间锁定 scrollspy，避免滚动过程中高亮闪烁
    isAnchorScrolling = false;
    anchorScrollTimer: number | null = null;

    saveLoading = false;
    merchantStoreSelectLoading = false;
    allMerchantStoreList = [];
    pageTypeList = [];

    defaultImgStatusStoreInfo = []; // 展示默认头像门店
    isShowImgStoreInfo = []; // 头像展示门店
    defaultImgStoreShowCount = 20; // 默认头像门店展示数量
    isShowImgStoreShowCount = 20; // 头像展示门店展示数量

    formData = {
        id: "",
        companyName: "",
        homepageMainTitle: "数智(AI)健康服务系统", // 首页主标题
        homepageSubTitle: "DIGITAL INTELLIGENCE (AI) HEALTH SERVICE SYSTEM", // 首页副标题
        homePageType: "", // 首页类型
        defaultImgStatus: false,
        isShowImg: false,
        defaultImgUrl: [],
        chineseMedicineLogo: [],
        backgroundImgUrl: [],
        showName: "",
        logoImgUrl: [],
        appImgUrl: [],
        wsTopImg: [],
        wsBigTitleImg: [],
        wsAppBackImg: [],
        wsRatioImg: [],
        wsMainLogo: [],
        wsBgImg: [],
        wsCountImg: [],
        wsTongueImg: [],
    };

    formRules = {
        homepageMainTitle: [{ required: true, message: "请输入首页主标题", trigger: "blur" }],
        homePageType: [{ required: true, message: "请选择首页类型", trigger: "change" }],
    };

    mounted() {
        // 先加载门店列表，再加载详情（详情需要门店列表做ID→名称映射）
        getStoreListByMerchant({ merchantId: this.merchantId }).then((res) => {
            this.allMerchantStoreList = res.data;
            this.getDetail();
        });
        this.getPageTypeList();
    }

    beforeDestroy() {
        if (this.anchorScrollTimer) {
            clearTimeout(this.anchorScrollTimer);
            this.anchorScrollTimer = null;
        }
    }

    getPageTypeList() {
        detectionTypeList().then((res) => {
            this.pageTypeList = res.data || [];
        })
    }

    getDetail() {
        getMerchantDetail(this.merchantId).then((res) => {
            const d = res.data || {};
            this.formData = {
                id: d.id ?? "",
                companyName: d.companyName ?? "",
                homepageMainTitle: d.homepageMainTitle ?? "数智(AI)健康服务系统",
                homepageSubTitle: d.homepageSubTitle ?? "",
                homePageType: d.homePageType ?? "",
                defaultImgStatus: Boolean(d.defaultImgStatus),
                isShowImg: Boolean(d.isShowImg),
                defaultImgUrl: d.defaultImgUrl ?? [],
                chineseMedicineLogo: d.chineseMedicineLogo ?? [],
                backgroundImgUrl: d.backgroundImgUrl ?? [],
                showName: d.showName ?? "",
                logoImgUrl: d.logoImgUrl ?? [],
                appImgUrl: d.appImgUrl ?? [],
                wsTopImg: d.wsTopImg ?? [],
                wsBigTitleImg: d.wsBigTitleImg ?? [],
                wsAppBackImg: d.wsAppBackImg ?? [],
                wsRatioImg: d.wsRatioImg ?? [],
                wsMainLogo: d.wsMainLogo ?? [],
                wsBgImg: d.wsBgImg ?? [],
                wsCountImg: d.wsCountImg ?? [],
                wsTongueImg: d.wsTongueImg ?? [],
            };
            // 展示默认头像门店 / 头像展示门店（后端返回纯ID数组，需映射门店名称）
            const storeMap = new Map(this.allMerchantStoreList.map((s: any) => [s.id, s.name]));
            this.defaultImgStatusStoreInfo = (d.defaultImgStatusStoreIds || []).map((id: number) => ({ id, storeName: storeMap.get(id) || String(id) }));
            this.isShowImgStoreInfo = (d.isShowImgStoreIds || []).map((id: number) => ({ id, storeName: storeMap.get(id) || String(id) }));
        })
    }

    getMerchantStoreRemote = debounce(function (str) {
        this.merchantStoreSelectLoading = true;
        getStoreListByMerchant({merchantId: this.merchantId, name: str}).then((res) => {
          this.merchantStoreSelectLoading = false;
          this.allMerchantStoreList = res.data;
        }).catch((err) => {}).finally(() => {
            this.merchantStoreSelectLoading = false;
        });
    })

    getMerchantStoreList(str) {
        if (typeof str == "object") {
          str = "";
        }
        this.getMerchantStoreRemote(str)
    }

    setCurUser(cur, key) {
        if (!cur?.id) return;
        this[key].push({ ...cur, userId: cur.id });
        const comparator = (obj1, obj2) => obj1.id === obj2.id;
        this[key] = uniqWith(this[key], comparator)
    }

    handleClose(cur, key) {
        this[key] = this[key].filter((item) => {
            return item.id != cur.id;
        });
    }

    // 点击锚点，平滑滚动到对应分组
    scrollToAnchor(id: string) {
        const box = this.editBoxRef;
        const el = box?.querySelector(`#anchor-${id}`) as HTMLElement | null;
        if (!box || !el) return;
        this.activeAnchor = id;
        // NOTE: 内容不足一屏时无可滚动，直接高亮点击项，避免滚动结束后 scrollspy 重新计算把高亮切回顶部
        if (box.scrollHeight <= box.clientHeight) {
            return;
        }
        this.isAnchorScrolling = true;
        const boxRect = box.getBoundingClientRect();
        const rect = el.getBoundingClientRect();
        const target = box.scrollTop + (rect.top - boxRect.top) - 80;
        box.scrollTo({ top: target, behavior: "smooth" });
        this.resetAnchorScrollTimer();
    }

    onScroll() {
        if (this.isAnchorScrolling) {
            this.resetAnchorScrollTimer();
            return;
        }
        this.updateActiveAnchor();
    }

    updateActiveAnchor() {
        const box = this.editBoxRef;
        if (!box) return;
        const boxRect = box.getBoundingClientRect();
        const threshold = 80;
        let current = this.anchorList[0].id;
        for (const item of this.anchorList) {
            const el = box.querySelector(`#anchor-${item.id}`) as HTMLElement | null;
            if (!el) continue;
            if (el.getBoundingClientRect().top <= boxRect.top + threshold) {
                current = item.id;
            }
        }
        this.activeAnchor = current;
    }

    resetAnchorScrollTimer() {
        if (this.anchorScrollTimer) clearTimeout(this.anchorScrollTimer);
        this.anchorScrollTimer = window.setTimeout(() => {
            this.isAnchorScrolling = false;
            this.anchorScrollTimer = null;
            this.updateActiveAnchor();
        }, 150);
    }

    dialogClose() {
        this.HomeInstance.tabRemove("merchantInterfaceManage");
    }

    dialogConfirm() {
        this.validateFormRef.validate().then(() => {
            const params = {
                id: this.formData.id,
                companyName: this.formData.companyName,
                homepageMainTitle: this.formData.homepageMainTitle,
                homepageSubTitle: this.formData.homepageSubTitle,
                homePageType: this.formData.homePageType,
                defaultImgStatus: Number(this.formData.defaultImgStatus),
                isShowImg: Number(this.formData.isShowImg),
                defaultImgStatusStoreIds: this.formData.defaultImgStatus ? this.defaultImgStatusStoreInfo.map((row: any) => row.id) : [],
                isShowImgStoreIds: this.formData.isShowImg ? this.isShowImgStoreInfo.map((row: any) => row.id) : [],
                defaultImgUrl: this.formData.defaultImgUrl[0]?.url || "",
                chineseMedicineLogo: this.formData.chineseMedicineLogo[0]?.url || "",
                backgroundImgUrl: this.formData.backgroundImgUrl[0]?.url || "",
                showName: this.formData.showName,
                logoImgUrl: this.formData.logoImgUrl[0]?.url || "",
                appImgUrl: this.formData.appImgUrl[0]?.url || "",
                wsTopImg: this.formData.wsTopImg[0]?.url || "",
                wsBigTitleImg: this.formData.wsBigTitleImg[0]?.url || "",
                wsAppBackImg: this.formData.wsAppBackImg[0]?.url || "",
                wsRatioImg: this.formData.wsRatioImg[0]?.url || "",
                wsMainLogo: this.formData.wsMainLogo[0]?.url || "",
                wsBgImg: this.formData.wsBgImg[0]?.url || "",
                wsCountImg: this.formData.wsCountImg[0]?.url || "",
                wsTongueImg: this.formData.wsTongueImg[0]?.url || "",
            };
            this.saveLoading = true;
            saveOrUpdateMerchant(params).then(() => {
                this.$message.success("保存成功");
                this.dialogClose();
            }).finally(() => {
                this.saveLoading = false;
            })
        });
    }
}
